// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment  = {
  baseUrl:'',
  stripe: {
    publicKey:
      'pk_test_51JVXwcCK92iTdGAQmTMKSEMHK2a0sI8SvLyss0Ks9ppmIWpDCBPPu5wF1YyC4UvMVgs7yuy6rvhoLNb1D4e4xYOz004WohZOhb',
  },
  production:false
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
